import { useEffect, useState } from "react";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import DateRangeSelector from "../../Common/DateRangeElement";
import { isValidObject, reverseDateFormat } from "../../utils";
import { getVehicleRenew } from "../../actions/vehicles";
import { headerColumn } from "../../constants";
import GenerateInvoice from "./components/GenerateInovice";
import SearchableDropdown from "../../Common/SearchDropdown";
import { shallowEqual, useSelector } from "react-redux";
import Invoice from "./components/Invoice";
import { PDFViewer } from "@react-pdf/renderer";

const isDatePassed = (inputDate) => {
    try {
        const date = new Date(inputDate);
        const now = new Date();
        // If input is an invalid date
        if (isNaN(date.getTime())) return false;

        return date < now;
    } catch (error) {
        return false;
    }
}

const Renewals = () => {
    const [state, setState] = useState({
        billings: [],
        list: [],
        billingCompanies: [],
        addbilling: false,
        loading: false,
        addCompany: false,
        currentDate: null,
        search: "",
        company: "",
        current: 1,
        total: 1,
        activeTab: "New",
        firstCall: false
    });

    const { companies, filters } = useSelector(({ companies, inventory }) => ({
        companies: companies?.companies ?? [],
        filters: inventory.filters ?? {}
    }), shallowEqual);

    const { addbilling, billings, loading, current, company, search, currentDate, companyId, firstCall, activeTab, list, billingCompanies } = state;

    const getBillings = (pageIndex = null) => {
        let query = `?page=${pageIndex ? pageIndex : current}&limit=200`;
        if (search) query = `${query}&keyword=${search}`;
        if (currentDate?.startDate && currentDate?.endDate) query = `${query}&startDate=${reverseDateFormat(currentDate?.startDate ?? "")}&endDate=${reverseDateFormat(currentDate?.endDate ?? "")}`;
        if (companyId) query = `${query}&companyId=${companyId}`;

        setState(prev => ({ ...prev, loading: true, firstCall: true }));
        getVehicleRenew(query).then(response => {
            const { data } = response.data;
            if (isValidObject(data)) {
                const billings = data?.vehicles ?? [];
                setState(prev => ({ ...prev, billings, total: data?.total ?? 1 }));
            }
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    useEffect(() => {
        if (!billings?.length) {
            setState(prev => ({ ...prev, billingCompanies: [] }));
            return;
        }
        const billingCompanies = [];
        billings.forEach(billing => {
            const billingCompanyId = billing.companyid ?? billing.companyId;
            const comp = companies.find(item => (item.companyId ?? item.companyid) == billingCompanyId);
            const compId = comp?.companyId ?? comp?.companyid;
            if (comp && !billingCompanies.find(item => (item.companyId ?? item.companyid) == compId)) {
                billingCompanies.push(comp);
            }
        });
        setState(prev => ({ ...prev, billingCompanies }));
    }, [billings, companies])

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
        getBillings(pageIndex)
    }

    const changeTab = (tab) => {
        const tabName = tab || "New";
        const list = [];
        billings?.forEach(item => {
            if (tabName == "Renewal") {
                if (item.is_renewal) list.push(item);
            } else {
                if (!item.is_renewal) list.push(item);
            }
        });
        setState(prev => ({ ...prev, activeTab: tabName, list }));
    }

    useEffect(() => changeTab(activeTab), [billings])

    useEffect(() => {
        if(firstCall || currentDate) paginationAction(1);
    }, [search, currentDate, company])

    return <div className="installer-container">
        <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} />
        <TableComponent col={4} breakPoint="lg" title={"Billing & Renewals"} headers={headerColumn.renewals} TabComponent={<div className="tabs p-1 rounded d-md-flex justify-content-between text-center">
                {["New", "Renewal"].map((tab, index) => <div className={`d-flex justify-content-center align-items-center rounded py-2 flex-fill ${activeTab == tab ? "active" : ""} mx-1`} key={index} onClick={() => changeTab(tab)}><div className="ms-2">{tab}</div>
                </div>)}
            </div>} data={list} tableLoading={loading} paginationAction={null} render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.companyname ?? "-"}</td>
            <td>{tdData?.vehiclenumber ?? "-"}</td>
            <td>{tdData?.billingcycle ?? "-"}</td>
            <td>{tdData?.billing_type ?? "-"}</td>
            <td>{tdData?.billingamount ?? 0}</td>
            <td>{tdData?.gstamount ?? 0}</td>
            <td>{tdData?.totalamount ?? 0}</td>
            <td className="status"><span className={isDatePassed(tdData?.nextduedate) ? "date-passed" : "date-not-passed"}>{tdData?.nextduedate ?? "-"}</span></td>
            <td>{tdData?.billingcompanyname ?? "-"}</td>
        </tr>} FilterComponent={<div className="installer-filters d-flex justify-content-end">
            <SearchableDropdown
                placeholder={"Company Name"}
                value={company}
                error={false}
                options={companies}
                onSelect={(value) => setState(prev => ({...prev, company: value?.name ?? "", companyId: value?.id ?? null }))}
            />
            <DateRangeSelector updateRange={(date) => setState(prev => ({...prev, currentDate: date }))} recentMonth={true} restrictMaxDate={true} />
            <ButtonElement text={"Generate Invoice"} cssClass="small-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, addbilling: true }))} variant="btn-black" />
        </div>} />

        {addbilling ? <GenerateInvoice show={addbilling} hideModal={() => setState(prev => ({ ...prev, addbilling: false }))} getInstData={getBillings} companies={billingCompanies} filters={filters} getVehicles={getVehicleRenew} currentDate={currentDate} /> : null}
    </div>
}

export default Renewals;